import React, { useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { useAuth } from "../../context/AuthContext";
import styles from "./Signin.module.css";
import NexLogo from "../../assets/svg/NexLogo";
import LoginCard from "./components/LoginCard";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";

// Imagens
import hermesWhite from "../../assets/img/hermes-white.png";

const SignIn: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const handleLogin = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (!email || !password) return;

    try {
      setLoading(true);
      await signIn(email, password);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      {/* Coluna da Esquerda (Marca / Branding) */}
      <div className={styles.brandColumn}>
        <div className={styles.brandHeader}>
          <NexLogo size={32} color="var(--color-secondary-300)" />
          <span className={styles.brandLogoName}>Nex</span>
        </div>

        <div className={styles.brandContent}>
          <span className={styles.tagline}>BEM-VINDO AO FUTURO</span>
          <h1 className={styles.mainTitle}>
            Potencialize sua operação com a inteligência modular <span>Nex</span>
          </h1>
          <p className={styles.description}>
            Plataforma industrial avançada. Integre visão computacional, controle de qualidade e automação em um ecossistema único.
          </p>

          <div className={styles.featureCards}>
            <LoginCard
              icon="visibility"
              title="NexVision"
              description="Visão computacional de alta precisão para análise em tempo real."
            />
            <LoginCard
              icon="security"
              title="NexShield"
              description="Controle de qualidade automatizado com tolerância zero a falhas."
            />
          </div>
        </div>

        <div className={styles.brandFooter}>
          powered by <img src={hermesWhite} alt="Hermes Reply" style={{ height: "48px" }} />
        </div>
      </div>

      {/* Coluna da Direita (Login / Auth) */}
      <div className={styles.loginColumn}>
        <div className={styles.loginWrapper}>
          <div className={styles.loginLogoWrapper}>
            <NexLogo size={48} color="var(--color-primary-900)" />
          </div>

          <div className={styles.loginHeader}>
            <h2>Bem-vindo de volta</h2>
            <p>Insira suas credenciais para acessar seu painel.</p>
          </div>

          <form className={styles.form} onSubmit={handleLogin}>
            <div className={styles.inputGroup}>
              <Input
                type="text"
                label="E-mail"
                placeholder="usuario@empresa.com"
                value={email}
                onChange={(val) => setEmail(val)}
                icon="mail"
                required
              />
            </div>

            <div className={styles.inputGroup}>
              <Input
                type="password"
                label="Senha"
                placeholder="••••••••"
                value={password}
                onChange={setPassword}
                icon="lock"
                required
                labelAction={
                  <a href="#" className={styles.forgotPassword}>
                    Esqueceu a senha?
                  </a>
                }
              />
            </div>

            <div className={styles.optionsRow}>
              <label className={styles.checkboxWrapper}>
                <Checkbox
                  inputId="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.checked || false)}
                />
                Lembrar de mim
              </label>
            </div>

            <Button
              type="submit"
              label="Entrar"
              loading={loading}
              style={{ width: "100%", marginTop: "8px", height: "48px", borderRadius: "8px" }}
            />


          </form>

          <footer className={styles.loginFooter}>
            Ao entrar, você concorda com os <a href="#">Termos de Uso</a> e a <a href="#">Política de Privacidade</a>.
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
